import React from "react";
import { resolveImageUrl } from "../lib/api";

const DEFAULT_THUMB =
  "https://images.unsplash.com/photo-1666618207644-4de0226a3f85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwd29ya3NwYWNlfGVufDB8fHx8MTc3NzM5MzA2N3ww&ixlib=rb-4.1.0&q=85";

const POSITIONS = [
  { top: "8%", left: "6%", drift: "tile-drift-a" },
  { top: "2%", right: "8%", drift: "tile-drift-b" },
  { bottom: "10%", left: "10%", drift: "tile-drift-c" },
  { bottom: "6%", right: "6%", drift: "tile-drift-d" },
  { top: "30%", right: "3%", drift: "tile-drift-e" },
  { top: "32%", left: "2%", drift: "tile-drift-f" },
];

export const FloatingTile = ({ post, onClick, index, number }) => {
  const layout = POSITIONS[index % POSITIONS.length];
  const { drift, ...pos } = layout;

  const href = `/?post=${encodeURIComponent(post.slug || "")}`;
  const handleClick = (e) => {
    // Let browser handle new-tab shortcuts (cmd/ctrl-click, middle-click,
    // right-click → "Open in new tab") — only intercept plain left-clicks
    // so the SPA modal still opens in-place.
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      e.altKey
    ) {
      return;
    }
    e.preventDefault();
    onClick(post);
  };

  return (
    <a
      href={href}
      onClick={handleClick}
      data-testid={`floating-tile-${post.slug || post.id || index}`}
      style={pos}
      className={`group absolute ${drift} z-20 hidden md:block no-underline text-inherit`}
      aria-label={`Open post ${post.title}`}
    >
      <div
        className="relative bg-white border border-black/90 hover:border-[#002FA7] transition-colors duration-300 shadow-[6px_6px_0_0_#0A0A0A] hover:shadow-[6px_6px_0_0_#002FA7] cursor-pointer text-left"
        style={{
          width: "clamp(160px, 14vw, 220px)",
          height: "clamp(160px, 14vw, 220px)",
        }}
      >
        <div className="h-1/2 w-full overflow-hidden border-b border-black/90">
          <img
            src={resolveImageUrl(post.thumb) || DEFAULT_THUMB}
            alt=""
            className="h-full w-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
            draggable={false}
          />
        </div>

        <div className="h-1/2 w-full p-3 flex flex-col justify-between">
          <div>
            <div className="flex items-center justify-between mb-1.5">
              <span className="font-display text-[9px] font-bold tracking-[0.18em] uppercase text-[#002FA7]">
                {post.tag || "Notes"}
              </span>
              <span className="font-display text-[9px] font-medium text-zinc-400">
                {String(number).padStart(2, "0")}
              </span>
            </div>
            <h3 className="font-display font-bold text-[12px] leading-[1.15] text-zinc-900 line-clamp-2">
              {post.title}
            </h3>
          </div>
          <p className="text-[10px] leading-snug text-zinc-500 line-clamp-2">
            {post.snippet}
          </p>
        </div>
      </div>
    </a>
  );
};

export default FloatingTile;
